import {
    TDashboardDictionaryType,
    IDashboardFilterEntity,
    IDashboardFilterSelectEntity,
    IDashboardFilterSelectItem,
    TDashboardListMutationTrigger,
    TDashboardMutationTrigger,
    IDictionary,
    ISectionSettings,
} from 'components/personal-account/tabs/dashboards/dashboards-types';
import {TStateSetter} from 'shared/types/generics';
import {showMessage} from 'shared/utils';

interface IUpdateDashboardSettingsActionProps {
    values: IDictionary<TDashboardDictionaryType>;
    dashboards?: ISectionSettings[];
    dashboardsSelects?: IDashboardFilterEntity[];
    setInitialData?: TStateSetter<IDictionary<TDashboardDictionaryType> | undefined>;
    uploadDashboard: TDashboardMutationTrigger;
    uploadDashboardList?: TDashboardListMutationTrigger;
}

export const updateDashboardSettingsAction = ({
    values,
    dashboards,
    dashboardsSelects,
    setInitialData,
    uploadDashboard,
    uploadDashboardList,
}: IUpdateDashboardSettingsActionProps) => {
    const promises: Promise<any>[] = [];

    if (values && dashboards) {
        const valueKeys = Object.keys(values).filter(key => typeof values[key] === 'boolean');
        const data = valueKeys.map((valueKey: string) => ({
            itemKey: dashboards.find(dashboard => dashboard.itemKey === valueKey)?.itemKey,
            isFavorite: values[valueKey] || false,
            menuName: valueKey,
            name: dashboards.find(dashboard => dashboard.itemKey === valueKey)?.name,
        }));

        if (data.length) promises.push(uploadDashboard(data as ISectionSettings[]));
    }

    if (uploadDashboardList) {
        const dashSelectsPost = dashboardsSelects?.map(item => (
            {
                itemKey: item.itemKey,
                selects: item.selects?.map((selItem: IDashboardFilterSelectEntity) => {
                    const initialFilter: number[] = values[selItem.selectCode] as number[] ?? [];
                    return (
                        {
                            selectTitle: selItem.selectTitle,
                            selectCode: selItem.selectCode,
                            selectValues: selItem.selectValues?.map(selValItem => (
                                {
                                    value: selValItem.value,
                                    isActive: initialFilter.includes(selValItem.value.id),
                                }
                            ) as IDashboardFilterSelectItem),
                        }
                    ) as IDashboardFilterSelectEntity;
                }),
            }
        ) as IDashboardFilterEntity);
        if (dashSelectsPost && dashSelectsPost.length) promises.push(uploadDashboardList(dashSelectsPost));
    }
    Promise.all(promises).then(() => {
        showMessage({message: 'Данные успешно сохранены'});
        if (setInitialData) setInitialData(values);
    }).catch(() => {
        showMessage({
            message: 'Произошла ошибка при сохранении данных',
            isError: true,
        });
    });
};
